import {createSlice} from '@reduxjs/toolkit';
import {
    sendVATsValues,
    setDiffFlag, setMileageType,
    setSdhHourPrice,
    setShowCarTable,
    setShowClientTable,
    setShowComplexity, setUpdateWorkOrder,
} from "../serverREST";
import {mileages} from "../locales/store";

export const VATs = {jobs: 'jobs', parts: 'parts'};
export const MaxVATOptionsCount = 7;

export const settingsSlice = createSlice({
    name: 'settingsReducer',
    initialState: {
        sdhHourPrice: 0,
        vats: {
            [VATs.jobs]: {
                active: false,
                type: 0,
                value: 20,
                options: [],
            },
            [VATs.parts]: {
                active: false,
                type: 0,
                value: 20,
                options: [10],
            },
        },
        showComplexity: false,
        showCarTable: false,
        showClientTable: false,
        diffFlag: -1,

        showHours: -1,

        hasPrintSettings: false,
        showCompanyInfo: false,
        showFromAccount: false,
        showLogoOnLeft: false,
        organization: '',
        companyName: '',
        companyTin: '',
        companyAddress: '',
        companyPhoneNumber: '',
        companyLogoObjectUrl: null,

        editWorkOrder: 0,
        mileageType: 'km',
        mileageOptions: mileages

    },
    reducers: {
        initVATs: (state, action) => {
            const payload = action.payload;

            for (const vatKey in VATs) {
                const vat = payload[vatKey];

                if (vat.options === null) {
                    vat.options = [];
                }
                state.vats[vatKey] = vat;
            }
        },
        changeVAT: (state, action) => {
            const {key, ...values} = action.payload;

            if (state.vats[key]) {
                state.vats[key] = {...state.vats[key], ...values};

                sendVATsValues({[key]: values});
            }
        },
        pushVATOption: (state, action) => {
            const {key, option} = action.payload;

            if (state.vats[key]) {
                const options = state.vats[key].options;

                if (!options.includes(option) && options.length < MaxVATOptionsCount) {
                    options.push(option);

                    sendVATsValues({[key]: {options: [...options]}});
                }
            }
        },
        popVATOption: (state, action) => {
            const {key, option} = action.payload;

            if (state.vats[key]) {
                const options = state.vats[key].options;
                const index = options.indexOf(option);

                if (index !== -1) {
                    options.splice(index, 1);

                    sendVATsValues({[key]: {options: [...options]}});
                }
            }
        },

        initSdhHourPrice: (state, action) => {
            state.sdhHourPrice = action.payload;
        },
        initShowComplexity: (state, action) => {
            state.showComplexity = action.payload;
        },
        initShowCarTable: (state, action) => {
            state.showCarTable = action.payload;
        },
        initShowClientTable: (state, action) => {
            state.showClientTable = action.payload;
        },
        initDiffFlag: (state, action) => {
            state.diffFlag = Number(action.payload);
        },

        initShowHours: (state, action) => {
            state.showHours = Number(action.payload);
        },

        initUpdateWork: (state, action) => {
            state.WorkFlag = Number(action.payload);
        },
        changeSdhHourPrice: (state, action) => {
            state.sdhHourPrice = action.payload;
            setSdhHourPrice(action.payload)
        },
        changeShowComplexity: (state, action) => {
            state.showComplexity = action.payload;
            setShowComplexity(action.payload)
        },
        changeShowCarTable: (state, action) => {
            state.showCarTable = action.payload;
            setShowCarTable(action.payload)
        },
        changeShowClientTable: (state, action) => {
            state.showClientTable = action.payload;
            setShowClientTable(action.payload)
        },
        changeUpdateWorkFlag: (state, action) => {
            state.editWorkOrder = Number(action.payload);
            setUpdateWorkOrder(action.payload);
        },

     /*   initWorkUpdateFlag: (state, action) => {
            state.WorkFlag = Number(action.payload);
        },

      */
        changeMileageType: (state, action) => {
            state.mileageType = action.payload;
            setMileageType(action.payload);
        },
     /*   initMileageType: (state, action) => {
            state.MileageType = action.payload;
        },*/
        changeDiffFlag: (state, action) => {
            state.diffFlag = Number(action.payload);
            setDiffFlag(action.payload)
        },
        changeShowHours: (state, action) => {
            state.showHours = Number(action.payload);
            // setShowHours(action.payload)
        },

        setHasPrintSettings: (state, action) => {
            state.hasPrintSettings = action.payload;
        },
        changeShowCompanyInfo: (state, action) => {
            state.showCompanyInfo = action.payload;
        },
        changeShowFromAccount: (state, action) => {
            state.showFromAccount = action.payload;
        },
        changeShowLogoOnLeft: (state, action) => {
            state.showLogoOnLeft = action.payload;
        },
        changeCompanyName: (state, action) => {
            state.companyName = action.payload;
        },
        changeOrganization: (state, action) => {
            state.organization = action.payload;
        },
        changeCompanyTin: (state, action) => {
            state.companyTin = action.payload;
        },
        changeCompanyAddress: (state, action) => {
            state.companyAddress = action.payload;
        },
        changeCompanyPhoneNumber: (state, action) => {
            state.companyPhoneNumber = action.payload;
        },
        changeCompanyLogoObjectUrl: (state, action) => {
            state.companyLogoObjectUrl = action.payload;
        },

        initSettingsProps: (state, action) => {
            //console.log({payload: action.payload})
            return {
                ...state,
                ...action.payload
            };
        }
    },
});

export const {
    initVATs,
    changeVAT,
    pushVATOption,
    popVATOption,

    initSdhHourPrice,
    initShowComplexity,
    initShowCarTable,
    initShowClientTable,
    initDiffFlag,
    initShowHours,
    changeSdhHourPrice,
    changeShowComplexity,
    changeShowCarTable,
    changeShowClientTable,
    changeDiffFlag,
    changeShowHours,

    setHasPrintSettings,
    changeShowCompanyInfo,
    changeShowFromAccount,
    changeShowLogoOnLeft,
    changeOrganization,
    changeCompanyName,
    changeCompanyTin,
    changeCompanyAddress,
    changeCompanyPhoneNumber,
    changeCompanyLogoObjectUrl,

    initWorkUpdateFlag,
    changeUpdateWorkFlag,
    changeMileageType,
    initMileageType,
    initSettingsProps

} = settingsSlice.actions;

export default settingsSlice.reducer;
